var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  default: () => primitive_default
});
var import_strictText = __toModule(require("../../../model/types/primitive/strictText"));
var import_address = __toModule(require("./address"));
var import_cadasterNumber = __toModule(require("./cadasterNumber"));
var import_checkbox = __toModule(require("./checkbox"));
var import_cif = __toModule(require("./cif"));
var import_date = __toModule(require("./date"));
var import_decimal = __toModule(require("./decimal"));
var import_integer = __toModule(require("./integer"));
var import_nie = __toModule(require("./nie"));
var import_nif = __toModule(require("./nif"));
var import_nifNie = __toModule(require("./nifNie"));
var import_nifNieCif = __toModule(require("./nifNieCif"));
var import_text = __toModule(require("./text"));
const TYPES = {
  Cadaster_number: import_cadasterNumber.default,
  Checkbox: import_checkbox.default,
  CIF: import_cif.default,
  Date: import_date.default,
  Decimal: import_decimal.default,
  Integer: import_integer.default,
  NIE: import_nie.default,
  NIF: import_nif.default,
  NIF_NIE: import_nifNie.default,
  NIF_NIE_CIF: import_nifNieCif.default,
  Text: import_text.default,
  StrictText: import_strictText.default,
  Address: import_address.default
};
var primitive_default = TYPES;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
